<!-- Card evento resumen horizontal parte izquierda -->
<div class="event-card-wrapper" (click)="changeEvent()">
    <div class="d-flex align-items-stretch h-100 flex-column">
        <div class="w-100">
            <div class="img-wrapper">
                <img class="img-card-event" [src]="event.imageurl && event.external ? event.imageurl : eventImgURL" />
            </div>
        </div>
        <div style="padding: 12px;">
            <div class="event-info"
                style="display:flex; justify-content: space-between; flex-direction: column;">
                <div class="event-title">
                    {{event.title | lowercase | titlecase}}
                </div>
                <div class="align-self-center date-event pointer-in date-wrapper"
                    style="color: var(--color-light); margin-top: 6px;">
                    <fa-icon class="icon-cart-line-trash" [icon]="faCalendar" style="padding-right: 6px;"></fa-icon>
                    <span>{{ (event.start_date | date: 'dd MMM':'+0000') }}</span>
                    <span *ngIf="event.end_date != event.start_date">-
                        {{ (event.end_date | date: 'dd MMM':'+0000') }}</span>
                    <span *ngIf="event.end_date == event.start_date"> | {{event.start_date | date: 'HH:mm':'+0000'}} </span>
                </div>
            </div>

        </div>
    </div>
</div>